import React from 'react';

export default function Shipping() {
  return <h2>Informazioni sulle Spedizioni</h2>;
}